import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-stock-menu',
    templateUrl: './stock-menu.component.html',
    styleUrls: ['./stock-menu.component.css'],
})
export class StockMenuComponent {
    /**
     * The name of the stock webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
